import ExportButton from '@/components/Chart/ExportButton';
import { useAppCsvExport } from '@/components/Chart/hooks/useAppCsvExport';
import useUserDetails from '@/hooks/useUserDetails';

const ExportCsvButton = ({
  tabName,
  disabled = false
}: {
  tabName: string;
  disabled?: boolean;
}) => {
  const { handleExport, exportDisabled } = useAppCsvExport(tabName, disabled);
  const { isUserExpired } = useUserDetails();
  const buttonDisabled = exportDisabled || isUserExpired;
  return (
    <ExportButton
      disabled={buttonDisabled}
      handleClick={handleExport}
      title='Download as CSV'
    />
  );
};

export default ExportCsvButton;
